import { handleResponseWithNon200Errors, makeGet } from './helpers';

/**
 * @category Shipping API
 * @see fetchItemShippingEstimate
 */
type FetchItemShippingEstimate = {
    authToken: string;
    countryCode: string;
    deployment: string;
    itemId: number;
    postalCode: string;
};

/**
 * Fetches a shipping estimate via Get from Shipping API
 * @function fetchItemShippingEstimate
 * @category Shipping API
 * @param {FetchItemShippingEstimate}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/shipping/estimate
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/2sprwrrwd6/resources/tztdqt/methods/GET
 * @see https://github.com/LIVEauctioneers/shipping-api/tree/master/functions/GetEstimate-shipping-api
 */
const fetchItemShippingEstimate = ({
    authToken,
    countryCode,
    deployment,
    itemId,
    postalCode,
}: FetchItemShippingEstimate) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            authToken,
            deployment,
            path: '<SHIPPING-API>estimate',
            queryParams: { countryCode, itemId, postalCode },
        });
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });

export default {
    fetchItemShippingEstimate,
};
